import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-right" }
const _hoisted_2 = { class: "text-right" }
const _hoisted_3 = { class: "text-right" }
const _hoisted_4 = { class: "text-right" }
const _hoisted_5 = { class: "text-right" }
const _hoisted_6 = { class: "text-right" }
const _hoisted_7 = { class: "py-2" }
const _hoisted_8 = { style: {"overflow-wrap":"anywhere"} }
const _hoisted_9 = { style: {"font-size":"11pt"} }
const _hoisted_10 = {
  key: 0,
  style: {"overflow-wrap":"anywhere"}
}
const _hoisted_11 = { style: {"font-size":"11pt"} }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "text-right" }
const _hoisted_15 = { class: "text-right" }
const _hoisted_16 = { class: "text-right" }
const _hoisted_17 = { class: "text-right" }
const _hoisted_18 = { class: "x-dense" }
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = { class: "text-right" }
const _hoisted_21 = { class: "text-right" }
const _hoisted_22 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "py-2" }, "Marges sur ventes", -1)),
    _createVNode(_component_v_row, { class: "d-flex justify-center" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "10" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_data_table, {
              headers: _ctx.salesMarginHeaders,
              items: _ctx.salesMargins,
              loading: _ctx.loading,
              class: "table",
              "fixed-header": "",
              "items-per-page": -1,
              "hide-default-footer": "",
              "multi-sort": false,
              density: "compact"
            }, {
              item: _withCtx(({ item }) => [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(item.product.title || "-"), 1),
                  _createElementVNode("td", _hoisted_1, _toDisplayString(_ctx.newCommonFormatCurrency(item.unitSalesPrice, undefined)), 1),
                  _createElementVNode("td", _hoisted_2, _toDisplayString(_ctx.newCommonFormatCurrency(item.salesPrice, undefined)), 1),
                  _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.newCommonFormatCurrency(item.directExpensePrice, undefined)), 1),
                  _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.newCommonFormatCurrency(item.indirectExpensePrice, undefined)), 1),
                  _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.newCommonFormatCurrency(item.expensePrice, undefined)), 1),
                  _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.newCommonFormatCurrency(item.margin, undefined)), 1)
                ])
              ]),
              _: 1
            }, 8, ["headers", "items", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.resourceMarginTitle), 1),
    _createVNode(_component_v_row, { class: "d-flex justify-center" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "10" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_data_table, {
              headers: _ctx.resourceAllocationHeaders,
              items: _ctx.resourceAllocationMargins,
              loading: _ctx.loading,
              class: "table",
              "fixed-header": "",
              "items-per-page": -1,
              "hide-default-footer": "",
              "multi-sort": false,
              density: "compact"
            }, {
              headers: _withCtx(() => [
                _createElementVNode("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resourceAllocationHeaders, (header, index) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: index,
                      class: _normalizeClass(`text-${header.align}`)
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(header.title), 1)
                      ]),
                      (header.measureUnit)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("span", _hoisted_11, "(" + _toDisplayString(header.measureUnit) + ")", 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
                ])
              ]),
              item: _withCtx(({ item }) => [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(item.name || "-"), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.mathFix(item.resourceQuantity, 0)), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.mathFix(item.yield, 2)), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.newCommonFormatCurrency(item.unitSalesPrice, undefined)), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.newCommonFormatCurrency(item.salesPrice, undefined)), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.newCommonFormatCurrency(item.expensePrice, undefined)), 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.newCommonFormatCurrency(item.margin, undefined)), 1)
                ])
              ]),
              "body.append": _withCtx(() => [
                _createElementVNode("tr", _hoisted_18, [
                  _cache[0] || (_cache[0] = _createElementVNode("td", { class: "text-left" }, [
                    _createElementVNode("strong", null, "Total")
                  ], -1)),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.mathFix(_ctx.totalResourceQuantity, 0)), 1),
                  _cache[1] || (_cache[1] = _createElementVNode("td", { class: "text-right" }, null, -1)),
                  _cache[2] || (_cache[2] = _createElementVNode("td", { class: "text-right" }, null, -1)),
                  _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.totalResourceSalesPrice, undefined)), 1),
                  _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.totalResourceExpensePrice, undefined)), 1),
                  _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.totalResourceMargin, undefined)), 1)
                ])
              ]),
              _: 1
            }, 8, ["headers", "items", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}